import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Logger, readFileAsText, FHIRService } from '@kailona/core';
import mapTCXtoFHIR from './mappers/mapTCXtoFHIR';
var logger = new Logger('Activities.importData');
/**
 * Import activities data from TCX file
 *
 * @param file
 */

export default function importData(_x) {
  return _importData.apply(this, arguments);
}

function _importData() {
  _importData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var fileAsText, observations, fhirCreateObservationsBundle, fhirService;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return readFileAsText(file);

          case 3:
            fileAsText = _context.sent;
            // Map TCX into FHIR Observations
            observations = mapTCXtoFHIR(fileAsText); // Store FHIR Observations

            fhirCreateObservationsBundle = {
              resourceType: 'Bundle',
              type: 'transaction',
              entry: observations.map(function (resource) {
                return {
                  resource: resource,
                  request: {
                    method: 'POST',
                    url: 'Observation'
                  }
                };
              })
            };
            fhirService = new FHIRService();
            _context.next = 9;
            return fhirService.transaction(fhirCreateObservationsBundle);

          case 9:
            return _context.abrupt("return", true);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            logger.error('Failed to import data', _context.t0);

          case 15:
            return _context.abrupt("return", false);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
  return _importData.apply(this, arguments);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/importData.js");
  reactHotLoader.register(importData, "importData", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/importData.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();